const { ASYNC } = require('../utils/redux-helpers');

module.exports = {
    UPDATE_PROFILE: ASYNC,
    UPDATE_PROFILE_PICTURE: ASYNC,
    CHANGE_USER_PASSWORD: ASYNC,
    UPDATE_USER_PREFERENCES: ASYNC,
    JOIN_SCHOOL: ASYNC,
    LEAVE_SCHOOL: ASYNC,
    SWITCH_SCHOOL: ASYNC
};
